import React from "react";
import { TextField } from "@fluentui/react";
export const XNumberField = (props) => {
    const onChanged = (_, value) => {
        value = value.split('').filter(o => !isNaN(Number(o))).join('');
        const numberValue = Number(value);
        props.onChanged(isNaN(numberValue) ? 0 : numberValue);
    };
    const value = typeof props.value === 'number'
        ? props.value.toString()
        : typeof props.value === 'string'
            ? props.value
            : '';
    return React.createElement(TextField, { autoComplete: "0", autoFocus: props.autoFocus, borderless: props.borderless, className: props.className, disabled: props.disabled || false, errorMessage: props.errorMessage || '', label: props.label || '', title: props.label || '', maxLength: props.maxLength, multiline: props.multiline, onChange: onChanged, onKeyDown: props.onKeyDown, onRenderPrefix: props.onRenderPrefix, onRenderSuffix: props.onRenderSuffix, placeholder: props.placeholder || props.label || '', readOnly: props.readonly || false, required: props.required || false, style: props.style, styles: props.styles, value: value });
};
